import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";

import FlowingCircles from "../../index/components/FlowingCircles";
import { ABOUT_HERO_SUBTITLE, ABOUT_HERO_TITLE } from "../aboutContent";

/**
 * 会社概要のヒーロー。背景は signin と同じ FlowingCircles、
 * 文字は /careers の CareersHeroTitle と同じ構成（din-2014 の英語大見出し +
 * AXIS L・字間 0.3em の日本語サブタイトル）。本文テキストは置かない。
 */
const HeroSection = styled(motion.section)`
  position: relative;
  width: 100%;
  height: 100dvh;
  overflow: hidden;
`;

/* FlowingCircles は要素の高さ中央を流れるので、少し下にずらして
   上寄せのコピーと合わせた全体の重心が画面中央に来るようにする */
const HeroBackground = styled.div`
  position: absolute;
  inset: 0;
  z-index: 0;
  transform: translateY(15dvh);
`;

/* コピーの中心は黄金比の位置（上から 38.2%） */
const HeroTagline = styled.div`
  position: absolute;
  top: 38.2%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  text-align: center;
  padding: 0 20px;
  z-index: 1;
  pointer-events: none;

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

const MainTitle = styled(motion.h1)`
  font-family: "din-2014-rounded-variable", sans-serif;
  font-variation-settings: "wght" 200;
  font-style: normal;

  font-size: clamp(4rem, 3.273rem + 3.64vw, 8rem);
  line-height: 100%;
  /* "Design with Sound" は文字数が多いので字間は広げない */
  letter-spacing: 0;

  color: #000;
`;

const SubTitle = styled(motion.p)`
  font-family: "A+mfCv-AXISラウンド 50 L StdN", "M PLUS 1p", sans-serif;
  font-weight: normal;

  font-size: clamp(1rem, 0.8rem + 1vw, 1.5rem);
  line-height: 150%;
  letter-spacing: 0.3em;

  color: #000;
`;

const AboutHero: React.FC = () => {
  return (
    <HeroSection
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1.5 }}
    >
      <HeroBackground>
        <FlowingCircles />
      </HeroBackground>
      <HeroTagline>
        <MainTitle
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.5 }}
        >
          {ABOUT_HERO_TITLE}
        </MainTitle>
        <SubTitle
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.8 }}
        >
          {ABOUT_HERO_SUBTITLE}
        </SubTitle>
      </HeroTagline>
    </HeroSection>
  );
};

export default AboutHero;
